import { useState } from "react";
import Button from "react-bootstrap/Button";
import Modal from "react-bootstrap/Modal";
import { Link } from "react-router-dom";
import useMessageTicket from "../../hooks/useMessageTicket";
import usePage from "../../hooks/usePage";
import Banner from "../../modules/pages/home/Components/Banner";
import FirstSegment from "../../modules/pages/home/FirstSegments/first";
import SecondSegment from "../../modules/pages/home/SecondSegment/second";
import Collaboratorr from "../../modules/pages/home/collaborators/collaborator";
import FooterPostup from "../../modules/public/footer/footer";
import Menu from "../../modules/public/menu/menu";
import "./home.css";

function Home() {
  const [state, setState] = useState({
    show: true,
    confirmUnreadMessages: false,
  });

  const { pageImage, pageSliders, pageText } = usePage();

  const { countUnreadMessages } = useMessageTicket();

  const handleClose = () => {
    setState(cur => ({ ...cur, show: false }));
  };

  return (
    <div className="homeStyles">
      <Modal show={false}>
        <Modal.Header className="d-flex align-item-center justify-content-center">
          <Modal.Title>توجه</Modal.Title>
        </Modal.Header>
        <Modal.Body
          className="d-flex align-item-center justify-content-center text-right"
          style={{ textAlign: "right", fontSize: "18px" }}
        >
          کاربر گرامی با عرض پوزش سیستم در حال به روز رسانی می باشد.
        </Modal.Body>
        <Modal.Footer className="d-flex align-item-center justify-content-center">
          <Button className="btn-cancel-style" onClick={() => handleClose()}>
            بستن
          </Button>
        </Modal.Footer>
      </Modal>

      <Menu />

      {pageSliders}

      {pageText}

      <FirstSegment />
      <SecondSegment />
      <Banner />
      <Collaboratorr />

      {pageImage}

      <FooterPostup />

      <Modal show={countUnreadMessages > 0 && !state.confirmUnreadMessages}>
        <Modal.Header
          style={{ fontWeight: "700", fontSize: "1.3rem" }}
          className="bg-white"
        >
          <span style={{ color: "#ff6927" }}>پیام ها</span>
        </Modal.Header>
        <Modal.Body className="px-3 bg-white">
          <p className="text-end mb-5" style={{ fontSize: "1.2rem" }}>
            شما{" "}
            <strong style={{ fontWeight: "1.1rem" }}>
              {countUnreadMessages}
            </strong>{" "}
            پیام خوانده نشده دارید.
            <br /> لطفا ابتدا آن ها را مطالعه کنید
          </p>

          <Link to="/messages">صفحه ی پیام ها</Link>
        </Modal.Body>
        <Modal.Footer className="bg-white">
          <button
            className="btn btn-danger"
            onClick={() =>
              setState(cur => ({ ...cur, confirmUnreadMessages: true }))
            }
          >
            متوجه شدم
          </button>
        </Modal.Footer>
      </Modal>
    </div>
  );
}

export default Home;
